import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const postCreateWithdrawals = (params) => {
    return axios.post(`${backendHost}/api/admin/withdrawal/create-withdrawals`, params);
};